import { StyleSheet, Platform } from "react-native";

export const RepositColours = {
  blue: "#4698CB",
  textGrey: "#4D4D4F",
  lightGrey: "#BBBBBB",
};

export const RepositStyles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  nextSub: {
    color: "#B5B5B5",
    marginVertical: 5,
    paddingHorizontal: Platform.OS === "ios" ? 8 : 0,
  },
  welcomeText: {
    color: RepositColours.textGrey,
    fontSize: 20,
    textAlign: "left",
  },
  headerText: {
    color: RepositColours.textGrey,
    fontSize: 24,
    textAlign: "center",
    lineHeight: 30,
    fontWeight: "300",
    marginHorizontal: 20,
  },
  paragraphText: {
    color: RepositColours.textGrey,
    textAlign: "left",
    fontSize: 14,
    marginHorizontal: 40,
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
});

export const errorColors = {
  green: "#51C76D",
  orange: "#F0A436",
  red: "#E02154",
};



// WEBPACK FOOTER //
// ./src/utils/styles.js